import CloseIcon from '@mui/icons-material/Close'
import { Box, Stack } from '@mui/material'
type Props = {
  listCurrentTagsFilter: { value: string; attributeCode: string }[]
  handleRemoveTag: (tag: { value: string; attributeCode: string }) => void
}

export const CurrentFilterTag = ({ listCurrentTagsFilter, handleRemoveTag }: Props) => {
  if (listCurrentTagsFilter.length === 0) return null
  return (
    <Stack direction="row" flexWrap={'wrap'} gap={1}>
      {listCurrentTagsFilter?.map((tag) => (
        <Box
          key={`${tag.value}`}
          sx={{
            bgcolor: 'grey.200',
            px: 1,
            py: 0.5,
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: 14,
            cursor: 'pointer',
            transition: 'all 0.2s',
            '&:hover': { backgroundColor: 'primary.main', color: 'common.white' },
          }}
        >
          {tag.value} <CloseIcon fontSize="inherit" onClick={() => handleRemoveTag(tag)} />
        </Box>
      ))}
    </Stack>
  )
}
